"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetProductsByTypeQueryDto = exports.GetProductsByTypeDto = exports.ArchiveMultipleProductsDto = exports.ArchiveDto = exports.SetStationSubcategoriesDto = exports.GetSubcategoryDto = exports.UpdateSubcategoryDto = exports.CreateSubcategoriesDto = exports.CreateSubcategoryDto = exports.GetBySessionType = exports.GetByCustomerIdDto = exports.GetAllOrganizationAddonsOptionsDto = exports.GetByOrgIdInvoiceIdDto = exports.FindByProductUserIdsDto = exports.FindPricesOfProductsDto = exports.SharedResourceInfo = exports.FindPriceOfProductDto = void 0;
const general_dto_1 = require("../../dto/general.dto");
const organization_dto_1 = require("../../organization/dto/organization.dto");
class FindPriceOfProductDto {
}
exports.FindPriceOfProductDto = FindPriceOfProductDto;
class SharedResourceInfo {
}
exports.SharedResourceInfo = SharedResourceInfo;
class FindPricesOfProductsDto {
}
exports.FindPricesOfProductsDto = FindPricesOfProductsDto;
class FindByProductUserIdsDto {
}
exports.FindByProductUserIdsDto = FindByProductUserIdsDto;
class GetByOrgIdInvoiceIdDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.GetByOrgIdInvoiceIdDto = GetByOrgIdInvoiceIdDto;
class GetAllOrganizationAddonsOptionsDto {
}
exports.GetAllOrganizationAddonsOptionsDto = GetAllOrganizationAddonsOptionsDto;
class GetByCustomerIdDto extends general_dto_1.PaginationQuery {
}
exports.GetByCustomerIdDto = GetByCustomerIdDto;
class GetBySessionType {
}
exports.GetBySessionType = GetBySessionType;
class CreateSubcategoryDto {
}
exports.CreateSubcategoryDto = CreateSubcategoryDto;
class CreateSubcategoriesDto {
}
exports.CreateSubcategoriesDto = CreateSubcategoriesDto;
class UpdateSubcategoryDto {
}
exports.UpdateSubcategoryDto = UpdateSubcategoryDto;
class GetSubcategoryDto {
}
exports.GetSubcategoryDto = GetSubcategoryDto;
class SetStationSubcategoriesDto {
}
exports.SetStationSubcategoriesDto = SetStationSubcategoriesDto;
class ArchiveDto {
}
exports.ArchiveDto = ArchiveDto;
class ArchiveMultipleProductsDto extends ArchiveDto {
}
exports.ArchiveMultipleProductsDto = ArchiveMultipleProductsDto;
class GetProductsByTypeDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.GetProductsByTypeDto = GetProductsByTypeDto;
class GetProductsByTypeQueryDto extends general_dto_1.PaginationQuery {
}
exports.GetProductsByTypeQueryDto = GetProductsByTypeQueryDto;
//# sourceMappingURL=product-pricing.dto.js.map